import { MonthZeroBased } from '@deltasierra/shared';
import { DateTime } from 'luxon';

export interface FormatOptions {
    locale?: 'en-AU';
    monthFormat?: 'long';
    yearFormat?: 'numeric';
    weekdayFormat?: 'narrow';
}

function iterateThrough(count: number): number[] {
    return Array.from(new Array(count)).map((_, i) => i);
}

export interface UseMonthFormatResponse {
    monthLabel: string;
    weekLabels: string[];
}

export function useMonthFormat(
    year: number,
    month: MonthZeroBased,
    fmtOptions: FormatOptions = {},
): UseMonthFormatResponse {
    const { locale = 'en-au', monthFormat = 'long', weekdayFormat = 'narrow', yearFormat = 'numeric' } = fmtOptions;
    const monthFmt = Intl.DateTimeFormat(locale, { month: monthFormat, year: yearFormat });
    const monthLabel = monthFmt.format(new Date(year, month));

    const weekFmt = Intl.DateTimeFormat(fmtOptions.locale ?? 'en-us', { weekday: weekdayFormat });
    const weekdays = iterateThrough(7).map(days => DateTime.now().startOf('week').plus({ days }).toJSDate());
    const weekLabels = weekdays.map(date => weekFmt.format(date));
    return {
        monthLabel,
        weekLabels,
    };
}
